import request from '../request'
import requestUrl from '../requestUrl'
import requestParam from '../requestParam'

/**
 * 获取用户的地址，CN或Overseas IP
 */
export const getUserRegion = () => {
    return request({
        url: requestUrl('/client/user/getUserRegion'),
        method: 'post',
        data: {}
    })
}
/**
 * 外部用户登陆
 * @param {*} s
 */
export const login = (params) => {
    return request({
        url: requestUrl('/client/user/login'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 内部用户登陆
 * @param {*} s
 */
export const KPMGLogin = (params) => {
    return request({
        url: requestUrl('/user/info'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 内部用户获取权限信息（数据跨境）
 */
export const getClientAuthorityInfo = (params) => {
    return request({
        url: requestUrl('/client/user/getClientAccessType'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 登出
 * @param {*} s
 */
export const logout = (params) => {
    return request({
        url: requestUrl('/client/user/logout'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 校验账号
 * @param {*} s
 */
export const checkAccount = (params) => {
    return request({
        url: requestUrl('/client/user/checkAccount'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 登陆获取验证码
 * @param {*} s
 */
export const verificationLogin = (params) => {
    return request({
        url: requestUrl('/client/user/verification'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 预登陆
 * @param {*} s
 */
export const preLogin = (params) => {
    return request({
        url: requestUrl('/client/user/preLogin'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 获取秘钥
 * @param {*} s
 */
export const secretKey = (params) => {
    return request({
        url: requestUrl('/client/user/secretKey'),
        method: 'get',
        data: requestParam(params)
    })
}

/**
 * 修改密码
 * @param {*} s
 */
export const updataPassword = (params) => {
    return request({
        url: requestUrl('/client/user/update/approval'),
        method: 'post',
        data: requestParam(params)
    })
}

export const updatePwdPop = (params) => {
    return request({
        url: requestUrl('/client/user/update/pwd/pop'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 忘记密码验证码
 * @param {*} s
 */
export const forgetCode = (params) => {
    return request({
        url: requestUrl('/client/user/forget/code'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 忘记密码
 * @param {*} 
 */
export const forgetUpdatePassword = (params) => {
    return request({
        url: requestUrl('/client/user/forget'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 修改用户名
 * @param {*} s
 */
export const updateUserName = (params) => {
    return request({
        url: requestUrl('/client/user/update'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 权限判断
 * @param {*} s
 */
export const authUser = (params) => {
    return request({
        url: requestUrl('/user/auth'),
        method: 'get',
        params: requestParam(params, 'get')
    })
}

/**
 * 查询当前site下的Client 联系人
 * @param {*} s
 */
export const queryClientContact = (params) => {
    return request({
        url: requestUrl('/client/site/queryClientContact'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询当前site下的Kpmg 联系人
 * @param {*} s
 */
export const queryKPContact = (params) => {
    return request({
        url: requestUrl('/client/site/queryKPContact'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询当前用户在site下的Entity
 * @param {*} s
 */
export const queryUserEntity = (params) => {
    return request({
        url: requestUrl('/client/site/queryUserEntity'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询当前用户在site下的是否需要弹窗
 * @param {*} s
 */
export const queryShowClientAdminPop = (params) => {
    return request({
        url: requestUrl('/siteConfig/queryShowClientAdminPop'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 用户确认不授权
 * @param {*} s
 */
export const setShowClientAdminPop = (params) => {
    return request({
        url: requestUrl('/siteConfig/setShowClientAdminPop'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 查询站点是否展示vat信息
 * @param {*} s
 */
export const queryShowVatInformation = (params) => {
    return request({
        url: requestUrl('/siteConfig/queryShowVatInformation'),
        method: 'post',
        data: requestParam(params)
    })
}


/**
 * 忘记密码邮件
 * @param {*} s
 */
export const gorgetLink = (params) => {
    return request({
        url: requestUrl('/client/user/forget/link'),
        method: 'post',
        data: requestParam(params)
    })
}
/**
 * 验证验证码
 * @param {*} s
 */
export const validationCode = (params) => {
    return request({
        url: requestUrl('/client/user/forget/verification/valid'),
        method: 'post',
        data: requestParam(params)
    })
}

/**
 * 忘记密码邮件
 * @param {*} s
 */
export const changeLanguage = (params) => {
    return request({
        url: requestUrl('/client/user/language'),
        method: 'post',
        data: requestParam(params)
    })
}

/*
Contact us upload
*/
export const contactUs = (params) => {
    return request({
        url: requestUrl('/client/user/contactUs'),
        method: 'post',
        data: params,
        timeout: 900000,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 显示 隐藏列
export const queryFixColumns = (params) => {
    return request({
        url: requestUrl('/client/user/fixColumns/queryFix'),
        method: 'post',
        data: requestParam(params)
    })
}
//
export const saveFixColumns = (params) => {
    return request({
        url: requestUrl('/client/user/fixColumns/saveFix'),
        method: 'post',
        data: requestParam(params)
    })
}

export const getDict = (params) => {
    return request({
        url: requestUrl(`/client/getDict/${params.dictName}`),
        method: 'get'
    })
}

export const commonDeleteFile = (data) => {
    return request({
        url: requestUrl(data.url),
        method: 'post',
        data: requestParam(data.params)
    })
}

// 查询系统更新状态
export const queryBehavior = () => {
    return request({
        url: requestUrl('/userBehavior/queryBehavior'),
        method: 'get'
    })
}

// 更新系统更新状态
export const updateBehavior = (params) => {
    return request({
        url: requestUrl('/userBehavior/updateBehavior'),
        method: 'post',
        data: requestParam(params)
    })
}
